import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-9',
  templateUrl: './9.component.html',
  styleUrls: ['./9.component.scss'],
})
export class VbTablesBootstrap9Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
